"use strict";

exports.__esModule = true;
exports.default = void 0;
var _group = _interopRequireDefault(require("./_group.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
var _default = exports.default = (0, _group.default)(function (result, value, pass) {
  result[pass ? 0 : 1].push(value);
}, true);